import { Component } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { slideInLeft } from 'ng-animate';
import { PianiTerapeuticiService } from 'src/app/services/pianiterapeutici.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-pianiterapeutici',
  templateUrl: './pianiterapeutici.component.html',
  styleUrl: './pianiterapeutici.component.css',
  animations: [
    trigger('slideInLeft', [transition('* => *', useAnimation(slideInLeft))])
  ],
})
export class PianiTerapeuticiComponent {
  slideInLeft: any;
  scrollLoading: boolean = false;
  loading: boolean = false;
  user: any = null;
  piani: Array<any> = [];
  index: number = 0;

  constructor(private PianiTerapeuticiService: PianiTerapeuticiService, private AuthService: AuthService) { }

  async ngAfterViewInit() { }

  async ngOnInit(): Promise<void> {
    this.fetchData()
  }

  async fetchData() {
    this.loading = true
    await this.AuthService.refresh()
    setInterval(() => { this.AuthService.refresh() }, 300000);
    await this.AuthService.checkToken()
    let user: object | null | undefined = await this.AuthService.getMe()
    this.user = user
    let listiPiani = await this.PianiTerapeuticiService.list(this.index);
    this.loading = false
    for (let piano of listiPiani) {
      this.piani.push(piano);
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }

  async onScrollDown() {
    this.scrollLoading = true;
    this.index = this.index + 20
    let listaPiani = await this.PianiTerapeuticiService.list(this.index);
    this.scrollLoading = false;
    this.loading = false
    for (let piano of listaPiani) {
      this.piani.push(piano);
      await new Promise(resolve => setTimeout(resolve, 100));
    }
  }
}
